module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_31.69250e6d.jpg";